import { render } from "./MaintenanceMode.vue?vue&type=template&id=bb6ed374&scoped=true&ts=true"
import script from "./MaintenanceMode.vue?vue&type=script&lang=ts"
export * from "./MaintenanceMode.vue?vue&type=script&lang=ts"

import "./MaintenanceMode.vue?vue&type=style&index=0&id=bb6ed374&scoped=true&lang=css"

import exportComponent from "/var/www/mmwapp/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb6ed374"]])

export default __exports__